export enum CognitoGroups {
  containerapiadmin = 'containerapiadmin',
  containerapiuser = 'containerapiuser',
  docdigitizeradmin = 'docdigitizeradmin',
  geodataadmin = 'geodataadmin',
  geodatauser = 'geodatauser',
  cognitoadmin = 'cognitoadmin',
}
